export default {
    isLoading: false,
    error: null,
    users: [],
    user: null,
}
